import Route from '@ember/routing/route';
import type Transition from '@ember/routing/transition';
import Model from '@ember-data/model';
import type StocktakingModel from 'bcl/models/stocktaking';
import type StocktakingEntryModel from 'bcl/models/stocktaking-entry';
import type StocktakingRoute from 'bcl/routes/auth/stocktaking';

export function allowTransitionIfClean(route: Route, transition: Transition) {
  const model = route.controller.model as Model;
  if (model?.hasDirtyAttributes) {
    if (confirm('Es existieren ungesicherte Änderungen. Verwerfen?')) {
      if (model.orderEntries) {
        model.orderEntries.forEach((entry: Model) => {
          entry.rollbackAttributes();
        });
      }
      model?.rollbackAttributes();
    } else {
      transition.abort();
    }
  }
}

export function allowTransitionIfCleanStocktaking(
  route: StocktakingRoute,
  transition: Transition
) {
  if (transition.targetName === 'auth.stocktaking.name') {
    return true;
  }
  const stocktaking = route.controller.model?.stocktaking as StocktakingModel;
  const anyChanged = stocktaking?.stocktakingEntries.some(
    (ste: StocktakingEntryModel) => ste.hasDirtyAttributes && ste.hasSetAmount
  );

  if (anyChanged) {
    if (confirm('Es existieren ungesicherte Änderungen. Verwerfen?')) {
      stocktaking.stocktakingEntries.forEach((entry: Model) => {
        entry.rollbackAttributes();
      });
    } else {
      transition.abort();
    }
  }
}
